import templateUrl from './eventPanelTile.tpl.html';

angular.module('signalview.eventsPanel').directive('eventPanelTile', [
    'eventModal',
    'alertingService',
    '$location',
    '$q',
    'dashboardV2Service',
    'featureEnabled',
    function (eventModal, alertingService, $location, $q, dashboardV2Service, featureEnabled) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                event: '=',
                eventColors: '<?',
            },
            templateUrl,
            link: function ($scope) {
                function getDashboardNavigationContext() {
                    const currentPath = $location.path();
                    if (
                        !currentPath.startsWith('/dashboard/') &&
                        !currentPath.startsWith('/page/')
                    ) {
                        return $q.resolve(undefined);
                    }

                    const dashboardUrl = alertingService.getDashboardNavigationUrl(
                        currentPath,
                        $location.search()
                    );

                    // /page/:groupId is a dashboard group id, not the individual dashboard
                    // the event belongs to, so it can't be resolved to a dashboard name here.
                    const dashboardId = currentPath.startsWith('/dashboard/')
                        ? currentPath.split('/')[2]
                        : undefined;

                    if (!dashboardId) {
                        return $q.resolve(
                            alertingService.createAlertDetailsNavigationContext({ dashboardUrl })
                        );
                    }

                    return dashboardV2Service.get(dashboardId).then(
                        (dashboard) =>
                            alertingService.createAlertDetailsNavigationContext({
                                dashboardName: dashboard?.name || dashboard?.sf_dashboard,
                                dashboardUrl,
                            }),
                        () => alertingService.createAlertDetailsNavigationContext({ dashboardUrl })
                    );
                }

                $scope.showInfo = function () {
                    const event = $scope.event;
                    if (
                        featureEnabled('o11yAIITPageDefault') &&
                        event?.metadata?.sf_eventCategory === 'ALERT' &&
                        event?.id
                    ) {
                        getDashboardNavigationContext().then((navigationContext) => {
                            alertingService.navigateToAlertDetails(event.id, navigationContext);
                        });
                        return;
                    }

                    eventModal(event);
                };

                $scope.enterEventTile = function () {
                    $scope.$emit('eventTileMouseEnter', $scope.event.timestamp);
                };

                $scope.leaveEventTile = function () {
                    $scope.$emit('eventTileMouseLeave');
                };
            },
        };
    },
]);
